<header class="baer-header">
  <h1 id="support" class="site-page-title"><span class="large-font">BAER Reports</span></h1>
  <h4 class="status-div">Create custom reports by selecting columns and applying filters</h4>
</header>
<main id="main-content" class="main-content">
  @if (showInfo) {
    <div class="blue-warning">
      <fa-icon [icon]="faCircleInfo" class="faCircleInfo" aria-label="Info"></fa-icon>
      <div class="support-text">
        <b>How to create a report</b>
        <p>Click "Select Report Columns" to choose which data fields to display. Drag the grip handles to reorder
          columns. Filter controls will appear automatically for selected columns.
        Use "Apply Filters" to refresh results and "Export to CSV" to download your custom report.</p>
      </div>
      <button class="delete-div" (click)="showInfo = false" matTooltip='hide' matTooltipClass="tooltipClass">
        <fa-icon [icon]="faCircleXmark" class="delete-row-icon" aria-label="close"></fa-icon>
      </button>
    </div>
  }

  <mat-card>
    <mat-card-content class="config-card">
      <div class="config-text">
        <b>Report Configuration</b>
        <p>Selected Columns ({{selectedColumns?.length ?? 0}})</p>
      </div>
      <button class="usa-button longer-button" (click)="setColumns()">
        <mat-icon>add</mat-icon> Select Report Columns
      </button>
      <div class="column-list" [nxtSortablejs]="selectedColumns">
        @for (column of selectedColumns; track column) {
          <mat-chip class="chip">
            <mat-icon class="drag-indicator">drag_indicator</mat-icon>
            {{column.name}}
            <button class="remove-btn" (click)="removeCol(column)">
              <mat-icon>close</mat-icon>
            </button>
          </mat-chip>
        }
      </div>
      @if (selectedColumns?.length > 0) {
        <div class="bar"></div>
      }
      @if (selectedColumns?.length > 0) {
        <div class="filters">
          <app-reports-filters [selectedColumns]="selectedColumns" (sendRun)="runReport($event)"></app-reports-filters>
        </div>
      }
    </mat-card-content>
  </mat-card>
  <div class="count">
    {{(dataSource.data.length ?? 0)}} record(s) found
    <button class="usa-button usa-button--secondary export-btn" (click)="exportToCsv()">
      <span class="export-button-text"><fa-icon class="fa-solid export-icon" [icon]="faDownload"></fa-icon>
    &nbsp;Export to CSV</span>
  </button>
</div>
@if ((selectedColumns?.length ?? 0) == 0) {
  <mat-card>
    <mat-card-content class="empty-card">
      <div class="no-data">
        <div class="no-data-icon">
          <img class="no-data-icon3" src="assets/img/empty-state-page.svg" alt="No Reports">
        </div>
        <div class="no-data-title">No Columns Selected</div>
        <p>Get started by selecting the columns you want to include in your report.</p>
        <button class="usa-button longer-button" (click)="setColumns()">
          <mat-icon>add</mat-icon> Select Report Columns
        </button>
      </div>
    </mat-card-content>
  </mat-card>
}
<mat-card class="table-card" [class.is-hidden]="((dataSource.data.length ?? 0) == 0)">
  <table mat-table [dataSource]="dataSource" matSort multiTemplateDataRows>
    <!-- location -->
    <ng-container matColumnDef="region">
      <th mat-header-cell *matHeaderCellDef>Region</th>
      <td mat-cell *matCellDef="let record">{{record.region || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="forest_name">
      <th mat-header-cell *matHeaderCellDef>Forest</th>
      <td mat-cell *matCellDef="let record">{{record.forest_name || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="forest_org_code">
      <th mat-header-cell *matHeaderCellDef>ForestOrgCode</th>
      <td mat-cell *matCellDef="let record">{{record.forest_org_code || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="IRWIN_POO_state">
      <th mat-header-cell *matHeaderCellDef>State of Fire Origin</th>
      <td mat-cell *matCellDef="let record">{{record.IRWIN_POO_state || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="ranger_district">
      <th mat-header-cell *matHeaderCellDef>Ranger District</th>
      <td mat-cell *matCellDef="let record">{{record.ranger_district || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="IRWIN_POO_county">
      <th mat-header-cell *matHeaderCellDef>Counties</th>
      <td mat-cell *matCellDef="let record">{{record.IRWIN_POO_county || '--'}}</td>
    </ng-container>
    <!-- date -->
    <ng-container matColumnDef="calendar_year">
      <th mat-header-cell *matHeaderCellDef>Calendar Year</th>
      <td mat-cell *matCellDef="let record">{{record.calendar_year || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="fiscal_year">
      <th mat-header-cell *matHeaderCellDef>Fiscal Year</th>
      <td mat-cell *matCellDef="let record">{{record.fiscal_year || '--'}}</td>
    </ng-container>
    <!-- fire details -->
    <ng-container matColumnDef="baer_name">
      <th mat-header-cell *matHeaderCellDef>Fire/Complex Name</th>
      <td mat-cell *matCellDef="let record">{{record.baer_name || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="fire_start_date">
      <th mat-header-cell *matHeaderCellDef>Fire Start Date</th>
      <td mat-cell *matCellDef="let record">{{(record.fire_start_date | date:"MM/dd/yyyy") || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="IRWIN_unique_fire_identifier">
      <th mat-header-cell *matHeaderCellDef>Fire Number</th>
      <td mat-cell *matCellDef="let record">{{record.IRWIN_unique_fire_identifier || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="job_code">
      <th mat-header-cell *matHeaderCellDef>Fire Incident Job Code</th>
      <td mat-cell *matCellDef="let record">{{record.job_code || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="total_fire_acres">
      <th mat-header-cell *matHeaderCellDef>Total Fire Acres</th>
      <td mat-cell *matCellDef="let record">{{(record.total_fire_acres | number: '1.0-0') || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="source">
      <th mat-header-cell *matHeaderCellDef>Source</th>
      <td mat-cell *matCellDef="let record">{{record.source || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="acres_fsonly">
      <th mat-header-cell *matHeaderCellDef>Est. NFS Acres</th>
      <td mat-cell *matCellDef="let record">{{(record.acres_fsonly | number: '1.0-0') || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="fire_complexity">
      <th mat-header-cell *matHeaderCellDef>Complexity</th>
      <td mat-cell *matCellDef="let record">{{record.fire_complexity || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="containment_date_est">
      <th mat-header-cell *matHeaderCellDef>Est. Containment Date</th>
      <td mat-cell *matCellDef="let record">{{(record.containment_date_est | date:"MM/dd/yyyy") || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="containment_date">
      <th mat-header-cell *matHeaderCellDef>Containment Date (GIS)</th>
      <td mat-cell *matCellDef="let record">{{(record.containment_date | date:"MM/dd/yyyy") || '--'}}</td>
    </ng-container>
    <!-- assessment -->
    <ng-container matColumnDef="assessment_status">
      <th mat-header-cell *matHeaderCellDef>Assessment Status</th>
      <td mat-cell *matCellDef="let record">{{record.assessment_status || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="team_lead">
      <th mat-header-cell *matHeaderCellDef>Team Lead</th>
      <td mat-cell *matCellDef="let record">{{record.team_lead || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="team_needs">
      <th mat-header-cell *matHeaderCellDef>Team Needs</th>
      <td mat-cell *matCellDef="let record">{{record.team_needs || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="trainees_needed">
      <th mat-header-cell *matHeaderCellDef>Trainees</th>
      <td mat-cell *matCellDef="let record">{{record.trainees_needed || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="tentative_start_week">
      <th mat-header-cell *matHeaderCellDef>Tentative Start Date</th>
      <td mat-cell *matCellDef="let record">{{(record.tentative_start_week | date:"MM/dd/yyyy") || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="close_out_date">
      <th mat-header-cell *matHeaderCellDef>Close-Out Date</th>
      <td mat-cell *matCellDef="let record">{{(record.close_out_date | date:"MM/dd/yyyy") || '--'}}</td>
    </ng-container>
    <!-- report -->
    <ng-container matColumnDef="report_baer_name">
      <th mat-header-cell *matHeaderCellDef>Report Name</th>
      <td mat-cell *matCellDef="let record">{{record.report_baer_name || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="report_status">
      <th mat-header-cell *matHeaderCellDef>Report Status</th>
      <td mat-cell *matCellDef="let record">{{record.report_status || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="report_id">
      <th mat-header-cell *matHeaderCellDef>Report ID</th>
      <td mat-cell *matCellDef="let record">{{record.report_id || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="report_type">
      <th mat-header-cell *matHeaderCellDef>Report Type</th>
      <td mat-cell *matCellDef="let record">{{record.report_type || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="action_type">
      <th mat-header-cell *matHeaderCellDef>Action Type</th>
      <td mat-cell *matCellDef="let record">{{record.action_type || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="authorization_status">
      <th mat-header-cell *matHeaderCellDef>Authorization Status</th>
      <td mat-cell *matCellDef="let record">{{record.authorization_status || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="submission_date">
      <th mat-header-cell *matHeaderCellDef>Submission Date</th>
      <td mat-cell *matCellDef="let record">{{(record.submission_date | date:"MM/dd/yyyy") || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="team_members">
      <th mat-header-cell *matHeaderCellDef>BAER Team Members</th>
      <td mat-cell *matCellDef="let record">{{record.team_members || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="total_funding_req">
      <th mat-header-cell *matHeaderCellDef>Total Funding Requested</th>
      <td mat-cell *matCellDef="let record">{{record.total_funding_req || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="ro_auth">
      <th mat-header-cell *matHeaderCellDef>RO Authorized Funds</th>
      <td mat-cell *matCellDef="let record">{{record.ro_auth || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="wo_auth">
      <th mat-header-cell *matHeaderCellDef>WO Authorized Funds</th>
      <td mat-cell *matCellDef="let record">{{record.wo_auth || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="total_auth">
      <th mat-header-cell *matHeaderCellDef>Total Authorized Funds</th>
      <td mat-cell *matCellDef="let record">{{record.total_auth || '--'}}</td>
    </ng-container>
    <!-- treatment totals -->
    <ng-container matColumnDef="treatment_unit">
      <th mat-header-cell *matHeaderCellDef>Unit</th>
      <td mat-cell *matCellDef="let record">{{record.treatment_unit || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="treatment_plants">
      <th mat-header-cell *matHeaderCellDef>Plants</th>
      <td mat-cell *matCellDef="let record">{{record.treatment_plants || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="treatment_ground_cover">
      <th mat-header-cell *matHeaderCellDef>Ground Cover</th>
      <td mat-cell *matCellDef="let record">{{record.treatment_ground_cover || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="treatment_channel">
      <th mat-header-cell *matHeaderCellDef>Channel</th>
      <td mat-cell *matCellDef="let record">{{record.treatment_channel || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="treatment_heritage">
      <th mat-header-cell *matHeaderCellDef>Heritage</th>
      <td mat-cell *matCellDef="let record">{{record.treatment_heritage || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="treatment_roads">
      <th mat-header-cell *matHeaderCellDef>Roads</th>
      <td mat-cell *matCellDef="let record">{{record.treatment_roads || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="treatment_safety">
      <th mat-header-cell *matHeaderCellDef>Safety</th>
      <td mat-cell *matCellDef="let record">{{record.treatment_safety || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="treatment_monitoring">
      <th mat-header-cell *matHeaderCellDef>Monitoring</th>
      <td mat-cell *matCellDef="let record">{{record.treatment_monitoring || '--'}}</td>
    </ng-container>
    <!-- soil burn severity acres -->
    <ng-container matColumnDef="soil_burn_sev_developed">
      <th mat-header-cell *matHeaderCellDef>Developed</th>
      <td mat-cell *matCellDef="let record">{{record.soil_burn_sev_developed || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="soil_burn_sev_unburned">
      <th mat-header-cell *matHeaderCellDef>Unburned/Very Low</th>
      <td mat-cell *matCellDef="let record">{{record.soil_burn_sev_unburned || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="soil_burn_sev_low">
      <th mat-header-cell *matHeaderCellDef>Low</th>
      <td mat-cell *matCellDef="let record">{{record.soil_burn_sev_low || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="soil_burn_sev_moderate">
      <th mat-header-cell *matHeaderCellDef>Moderate</th>
      <td mat-cell *matCellDef="let record">{{record.soil_burn_sev_moderate || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="soil_burn_sev_high">
      <th mat-header-cell *matHeaderCellDef>High</th>
      <td mat-cell *matCellDef="let record">{{record.soil_burn_sev_high || '--'}}</td>
    </ng-container>
    <!-- user -->
    <ng-container matColumnDef="name">
      <th mat-header-cell *matHeaderCellDef>Name</th>
      <td mat-cell *matCellDef="let record">{{record.name || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="agency">
      <th mat-header-cell *matHeaderCellDef>Agency</th>
      <td mat-cell *matCellDef="let record">{{record.agency || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="skills_list">
      <th mat-header-cell *matHeaderCellDef>BAER Skills</th>
      <td mat-cell *matCellDef="let record">{{record.skills_list || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="skills_list_read">
      <th mat-header-cell *matHeaderCellDef>READ Skills</th>
      <td mat-cell *matCellDef="let record">{{record.skills_list_read || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="skill_level">
      <th mat-header-cell *matHeaderCellDef>Skill Level</th>
      <td mat-cell *matCellDef="let record">{{record.skill_level || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="fire_assignment">
      <th mat-header-cell *matHeaderCellDef>Fire Assignment Status</th>
      <td mat-cell *matCellDef="let record">{{record.fire_assignment || '--'}}</td>
    </ng-container>
    <ng-container matColumnDef="bear_role">
      <th mat-header-cell *matHeaderCellDef>Positions</th>
      <td mat-cell *matCellDef="let record">{{record.bear_role || '--'}}</td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let record; columns: displayedColumns;" class="example-element-row">
    </tr>

    <!-- Row shown when there is no matching data. -->
    <tr class="mat-row" *matNoDataRow>
      <td class="mat-cell" [attr.colspan]="(selectedColumns?.length ?? 0)">
        <div class="no-data">
          <div class="no-data-icon">
            <img class="no-data-icon3" src="assets/img/empty-state-page.svg" alt="No Reports">
          </div>
          <div class="no-data-title">No records found</div>
          <p>There are no records that match your current filters. Try removing some of them to get better
          results.</p>
        </div>
      </td>
    </tr>
  </table>
  <mat-paginator pageSize="20" [pageSizeOptions]="[5, 10, 20, 50]" showFirstLastButtons
    aria-label="Select page of report">
  </mat-paginator>
</mat-card>
</main>